import { adminFetch } from "./_client";

export interface AdminTranslation {
  text: string;
  detectedLanguage: string | null;
  alreadyTarget: boolean;
}

export interface AdminTranslateResponse {
  configured: boolean;
  results: AdminTranslation[];
}

/**
 * On-demand translation of user content (messages, reviews, notes…) into the
 * agent's language so English-only CS agents can read and moderate
 * international content. Defaults to English; pass a target language name to
 * override. Backed by POST /admin/translate.
 */
export function translateAdminContent(
  token: string,
  texts: string[],
  targetLang = "English",
) {
  return adminFetch<AdminTranslateResponse>("/admin/translate", token, {
    method: "POST",
    body: JSON.stringify({ texts, targetLang }),
  });
}
